import { Injectable } from '@angular/core'
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar'
import { NotificationComponent } from '../components/notification/notification.component'

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(private snackBar: MatSnackBar) {}

  private config: MatSnackBarConfig = {
    duration: 3000,
    verticalPosition: 'top',
    horizontalPosition: 'right',
  }

  success(msg: string, parameters: { [key: string]: string } = null, overrideConfig: MatSnackBarConfig = null): void {
    const config = { ...this.config, panelClass: ['success', 'notification'], ...overrideConfig }
    this.snackBar.openFromComponent(NotificationComponent, {
      ...config,
      data: { message: msg, duration: config.duration, isSuccess: true, parameters },
    })
  }

  error(msg: string, parameters: { [key: string]: string } = null, overrideConfig: MatSnackBarConfig = null): void {
    const config = { ...this.config, panelClass: ['error', 'notification'], ...overrideConfig }

    this.snackBar.openFromComponent(NotificationComponent, {
      ...config,
      data: { message: msg, duration: config.duration, isSuccess: false, parameters },
    })
  }
}
